export interface CallEvent {
    id: string;
    installation_id: string;
    state: CallEventState;
    timestamp: number;
    checked: boolean;
    images_urls: string[];
    thumbnail_url: string;
    caller: CallEventParticipant;
    callee: CallEventEntity;
    source: CallEventParticipant;
    sessions: any[];
    deviceName?: string;
    isOutgoing?: boolean;
}

export interface CallEventParticipant {
    peer_id: string;
    entity: CallEventEntity;
}

export interface CallEventEntity {
    id: string;
    kind: string;
}

export enum CallEventState {
    STARTED = 'started',
    REJECTED = 'rejected',
    MISSED = 'missed',
    ANSWERED = 'answered',
    BRIDGED = 'bridged',
    CANCELLED = 'canceled',
    FORWARDED = 'forwarded'
}
